import {
  MessagesInboxIcon,
  FavoriteIconRent,
  GuestsIcon,
  BathRoomIconRent,
  BedIconRent,
  NUSDIcon,
} from "../../../AssetComponents/Images";
import React, { useMemo, useCallback } from "react";
import { PurpleButton } from "../../../Components/Buttons/PurpleButton";
import { BlackButton } from "../../../Components/Buttons/BlackButton";
import { ChatItem, ReceivedMessage, SentMessage } from "./ChatItem";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { api, setAuthToken } from "../../../Components/functions/Api";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setMessageToSend,
  setReceivedMessage,
} from "../../../ReduxSlices/CommunicationSlice";
import {
  getTime,
  getDay,
  isRentalActive,
  shouldShowRentalInInbox,
  getProfileFromWallet,
  isSameWalletAddress,
  isSameChatMessage,
  dedupeChatMessages,
} from "../../../Components/functions/Functions";
import { HostAction } from "../HostReservations/HostAction";
import { TravelerAction } from "../TravelerTrips/TravelerAction";
import { removeItem } from "../../../ReduxSlices/NotificationSlice";
import { Fade } from "react-awesome-reveal";
import { toast } from "react-toastify";
import { RentalItem } from "../../../Components/RealEstateProperty/RentalItem";
import { Mainnet } from "@nibiruchain/nibijs";
import { NotificationImageWithFallback } from "../../../Components/Images/ImageWithFallback";
import { updateToken } from "../../../Components/functions/Functions";
import { updateNFTStore } from "../../../ReduxSlices/NFTSlice";
import Billing from "../../../assets/images/Dashboard/Dashboard/Billing";
import Host from "../../../assets/images/Dashboard/Dashboard/Host";
import Rental from "../../../assets/images/Dashboard/Dashboard/Rental";
import Active from "../../../assets/images/Dashboard/Dashboard/Active";
import Essential from "../../../assets/images/Dashboard/Dashboard/Essential";
import Addressfile from "../../../assets/images/Dashboard/Dashboard/Addressfile";
import RentalRequest from "../../../assets/images/Dashboard/Dashboard/RentalRequest";
import { ProfileRequiredModal } from "../../../Components/Rent/ProfileRequiredModal";
import Messages from "../../../assets/Dashboardsvg/Messages";
import Dashboardsearch from "../../../assets/Dashboardsvg/Dashboardsearch";
import TypeMessage from "../../../assets/Dashboardsvg/TypeMessage";
import TypeSearch from "../../../assets/Dashboardsvg/TypeSearch";
import SendMessage from "../../../assets/Dashboardsvg/SendMessage";
import { findOrCreateChat } from "../../../Components/functions/Functions";
import { updateTokenSafe } from "../../../Components/functions/Functions";
// 🔥 ADD: Import socket.io client
import { io } from "socket.io-client";
import { InboxMobile } from "./InboxMobile";
import Skeleton from "react-loading-skeleton"; // 🚀 PHASE 7: Import Skeleton for loading states

export const Inbox = ({ mode }) => {
  const [isMobile, setIsMobile] = useState(false);
  const ref = useRef(null);
  const [text, setText] = useState(null);
  const [time, setTime] = useState(null);
  const location = useLocation();
  const account = useSelector((state) => state.auth.account);
  const myProfile = useSelector((state) => state.auth.profile);
  const notificationItems = useSelector((state) => state.notification.items);
  const diff = useSelector((state) => state.time.diffToUTC);
  const [chats, setChats] = useState([]);
  const [messages, setMessages] = useState([]);
  const [chat, setChat] = useState();
  const [receiver, setReceiver] = useState();
  const [receiverProfile, setReceiverProfile] = useState();
  const [nftId, setNftId] = useState();

  const [avgRate, setAvgReviews] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [hasMoreMessages, setHasMoreMessages] = useState(false);
  const [reviewsByPeriod, setReviewsByPeriod] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [travelerAddress, setTravelerAddress] = useState();
  const [firstPeriod, setFirstPeriod] = useState();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  /** Avoid applying a stale socket payload after navigating to a new ?chat= */
  const prevChatParamRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [isLoadingNft, setIsLoadingNft] = useState(false); // 🚀 PHASE 7: Track NFT loading state

  // Listen for reservation updates and refresh the list
  useEffect(() => {
    const handleReservationUpdate = () => {
      console.log("Inbox reservation update detected, refreshing list...");
      setRefreshTrigger(prev => prev + 1);
    };

    // Listen for custom events from reservation actions
    window.addEventListener('reservationUpdated', handleReservationUpdate);
    window.addEventListener('reservationCancelled', handleReservationUpdate);
    window.addEventListener('reservationApproved', handleReservationUpdate);
    window.addEventListener('reservationFinalized', handleReservationUpdate);
    window.addEventListener('reservationRejected', handleReservationUpdate);
    window.addEventListener('reservationCreated', handleReservationUpdate);

    return () => {
      window.removeEventListener('reservationUpdated', handleReservationUpdate);
      window.removeEventListener('reservationCancelled', handleReservationUpdate);
      window.removeEventListener('reservationApproved', handleReservationUpdate);
      window.removeEventListener('reservationFinalized', handleReservationUpdate);
      window.removeEventListener('reservationRejected', handleReservationUpdate);
      window.removeEventListener('reservationCreated', handleReservationUpdate);
    };
  }, []);
  const nft = useSelector((state) => state.nft.nfts[nftId]);
  const mainnet = Mainnet();

  const getToken = async () => {
    if (!nftId) {
      console.log("❌ No nftId provided, skipping token fetch");
      return;
    }

    if (nft) {
      console.log("✅ Token already loaded:", nftId);
      return;
    }

    if (isLoadingNft) {
      console.log("🔄 Already loading token:", nftId);
      return;
    }

    console.log("🔄 Loading token:", nftId);

    try {
      setIsLoadingNft(true); // 🚀 PHASE 7: Set loading state
      // 🚀 INSTANT DASHBOARDS: Use backend API instead of RPC calls
      const propertyData = await api("property/getProperty", {
        token_id: nftId,
      });
      if (propertyData) {
        // 🔥 FIX: Validate metaData exists before storing in Redux
        if (!propertyData.metaData || typeof propertyData.metaData !== 'object') {
          console.warn("⚠️ Inbox: Invalid metaData received from backend:", {
            nftId,
            hasMetaData: !!propertyData.metaData,
            metaDataType: typeof propertyData.metaData
          });
          // Skip updating Redux with invalid data
          return;
        }
        
        // Update Redux with backend data (no RPC needed)
        dispatch(
          updateNFTStore({
            token_id: nftId,
            metaData: propertyData.metaData,
            short: propertyData.short,
            rentals: propertyData.rentals,
            access: propertyData.access,
          })
        );
        console.log("✅ Token loaded successfully from backend:", nftId);
      } else {
        // Fallback to RPC only if backend fails
        console.log("⚠️ Backend returned no data, falling back to RPC:", nftId);
        const success = await updateTokenSafe(
          {
            token_id: nftId,
            contract: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
          },
          mainnet.endptTm,
          dispatch
        );
        if (success) {
          console.log("✅ Token loaded successfully from RPC:", nftId);
        } else {
          console.log("❌ Failed to load token:", nftId);
        }
      }
    } catch (error) {
      console.error("💥 Error loading token:", nftId, error);
      // Try RPC fallback on error
      try {
        await updateTokenSafe(
          {
            token_id: nftId,
            contract: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
          },
          mainnet.endptTm,
          dispatch
        );
      } catch (rpcError) {
        console.error("💥 RPC fallback also failed:", nftId, rpcError);
      }
    } finally {
      setIsLoadingNft(false); // 🚀 PHASE 7: Clear loading state
    }
  };

  useEffect(() => {
    if (nftId && !nft) {
      getToken();
    }
  }, [nftId, nft]);

  const receivedMessage = useSelector(
    (state) => state.communication.receivedMessage
  );

  useEffect(() => {
    let flag = false;
    for (let i = 0; i < nft?.rentals?.rentals?.length; i++) {
      const reservation = nft?.rentals?.rentals[i];
      // 🔥 FIX: Only show active rentals or recently completed rentals (within 2 days)
      const shouldShow = shouldShowRentalInInbox(reservation, diff);
      
      if (reservation.address === account && mode === "traveler" && shouldShow) {
        setTravelerAddress(account);
        setFirstPeriod(reservation.renting_period);
        flag = true;
        break;
      }
      if (reservation.address === receiver && mode === "host" && shouldShow) {
        setTravelerAddress(receiver);
        setFirstPeriod(reservation.renting_period);
        flag = true;
        break;
      }
    }
    if (!flag) {
      setTravelerAddress(null);
      setFirstPeriod([]);
    }
  }, [chat, nft, account, receiver, diff]);

  useEffect(() => {
    if (!receivedMessage) return;

    console.log("🔥 Received real-time message:", receivedMessage);

    // 🚀 PHASE 7: Handle echo messages (from sender's own devices) vs real messages
    // Backend now sends _isEcho flag for sender's own messages
    const isEcho = receivedMessage._isEcho === true;
    const isFromSelf =
      isSameWalletAddress(receivedMessage.message?.sender, account) ||
      receivedMessage.message.sender === account;
    
    // 🔥 CRITICAL FIX: Use loose equality and string comparison to handle ID mismatches
    // Also check if chat is null/undefined and we should still add the message
    const chatIdMatches = receivedMessage.id === chat || 
                          String(receivedMessage.id) === String(chat) ||
                          receivedMessage.id == chat; // Loose equality as fallback
    
    // 🔥 CRITICAL FIX: Update chat ID if we receive a message with a new chat ID (from self)
    // This ensures subsequent messages use the correct chat ID when a new chat is created
    if (isFromSelf && receivedMessage.id && (!chat || String(chat) !== String(receivedMessage.id))) {
      console.log("🆕 Updating chat ID from received message:", {
        oldChat: chat,
        newChat: receivedMessage.id
      });
      setChat(receivedMessage.id);
    }
    
    // 🔥 FIX: ONLY add to current chat if it matches, including messages from self
    // Also add if chat is null and this is from self (new chat being created)
    const shouldAddMessage = chatIdMatches || (isFromSelf && !chat && receivedMessage.id);
    
    if (shouldAddMessage) {
      console.log(`✅ Adding received message to current chat (from self: ${isFromSelf})`);
      console.log("📝 Message details:", {
        hasText: !!receivedMessage.message.text,
        hasImage: !!receivedMessage.message.image,
        messageType: receivedMessage.message.messageType,
      });
      
      setMessages((prevMessages) => {
        const incoming = receivedMessage.message;
        const exists = prevMessages.some((msg) => isSameChatMessage(msg, incoming));
        if (exists) {
          console.log("🔄 Exact duplicate found, ignoring");
          return prevMessages;
        }
        const newMessages = [...prevMessages, incoming];
        return dedupeChatMessages(newMessages);
      });
      
      setTime(receivedMessage.message.generatedTime);
    } else {
      console.log("⚠️ Message not added - chat ID mismatch:", {
        receivedId: receivedMessage.id,
        currentChat: chat,
        isFromSelf: isFromSelf,
        hasChat: !!chat,
        chatIdMatches: chatIdMatches
      });
    }

    // 🚀 PHASE 7: Update chat list ONLY for real messages from others (not echo, not self)
    // Messages from self are already handled optimistically in sendMessage
    // Echo messages are for UI sync only, don't update chat list
    if (!isEcho && !isFromSelf) {
      // 🔥 FIX: Use loose equality for chat matching to handle type mismatches
      const matchingChat = chats.find((item) => {
        const itemId = String(item.chatId || '');
        const receivedId = String(receivedMessage.id || '');
        return itemId === receivedId || item.chatId == receivedMessage.id;
      });

      if (matchingChat) {
      setChats((prevChats) => {
        return prevChats
          .map((chatItem) => {
            // 🔥 FIX: Use loose equality for chat ID matching
            const chatItemId = String(chatItem.chatId || '');
            const receivedId = String(receivedMessage.id || '');
            const isMatchingChat = chatItemId === receivedId || chatItem.chatId == receivedMessage.id;
            
            if (isMatchingChat) {
              // 🔥 FIX: Use loose equality for current chat check
              const isCurrentChat = String(chat || '') === receivedId || chat == receivedMessage.id;
              
              return {
                ...chatItem,
                latestMessageTime: receivedMessage.message.generatedTime,
                unreadMessages:
                  !isCurrentChat
                    ? (chatItem.unreadMessages || 0) + 1
                    : chatItem.unreadMessages || 0,
              };
            }
            return chatItem;
          })
          .sort((a, b) => {
            const timeA = new Date(a.latestMessageTime).getTime();
            const timeB = new Date(b.latestMessageTime).getTime();
            
            // Handle invalid dates
            if (isNaN(timeA) && isNaN(timeB)) return 0;
            if (isNaN(timeA)) return 1;
            if (isNaN(timeB)) return -1;
            
            // Sort in descending order (newest first)
            return timeB - timeA;
          });
      });
      } else {
        // New chat not in list yet — refresh chats
        getChats(true);
      }
    }

    dispatch(setReceivedMessage(null));
  }, [receivedMessage, chat, account, mode, dispatch, chats]);

  // 🔥 FIX: Enhanced sendMessage with better chat management and unified identification
  const sendMessage = async () => {
    if (!myProfile) {
      setShowProfileModal(true);
      return;
    }
    if (!receiver) return;
    if (!text || text.trim() === "") {
      // If no text but has image, still allow sending
      if (!selectedImage) return;
    }
    if (!nftId) return;

    let textTosend = text || "";
    let imageUrl = null;

    // Upload image if selected
    if (selectedImage) {
      try {
        imageUrl = await uploadImageToPinata(selectedImage.file);
      } catch (error) {
        console.error("Failed to upload image:", error);
        return; // Don't send message if image upload fails
      }
    }

    const generatedTime = new Date();
    const messageTimeString = generatedTime.toISOString();

    // Determine message type
    const messageType = textTosend.trim() && imageUrl ? "text_image" : 
                       imageUrl ? "image" : "text";

    const MessageObj = {
      sender: account,
      generatedTime: messageTimeString,
      text: textTosend,
      image: imageUrl,
      messageType: messageType,
    };

    // 🔥 FIX: Enhanced sendingData with unified chat identification
    const sendingData = {
      id: chat,
      newMessage: MessageObj,
      sender: account,
      receiver: receiver,
      owner: nft?.access?.owner || receiver || account, // Ensure we always have a valid owner string
      nftId: nftId,
      propertyId: nftId, // Add property identifier for consistency
      mode: mode === "traveler" || mode === "host" ? "short" : "long",
      // 🔥 FIX: Add unique chat identifier to prevent duplicates
      chatIdentifier: `${Math.min(account, receiver)}_${Math.max(account, receiver)}_${nftId}_${mode}`,
    };

    console.log("🚀 Sending message with unified data:", sendingData);

    dispatch(setMessageToSend(sendingData));
    const localMessageObj = {
      sender: account,
      generatedTime: generatedTime.toISOString(),
      text: textTosend,
    };

    // 🔥 FIX: Update messages and time immediately
    setMessages((prevMessages) =>
      dedupeChatMessages([...prevMessages, MessageObj])
    );
    setTime(messageTimeString);
    setText("");
    setSelectedImage(null); // Clear selected image
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    // 🔥 FIX: Also update the chat list immediately with new time
    setChats((prevChats) => {
      return prevChats
        .map((chatItem) => {
          if (chatItem.chatId === chat) {
            return {
              ...chatItem,
              latestMessageTime: messageTimeString, // Use the exact time we just sent
            };
          }
          return chatItem;
        })
        .sort((a, b) => {
          const timeA = new Date(a.latestMessageTime).getTime();
          const timeB = new Date(b.latestMessageTime).getTime();
          
          // Handle invalid dates
          if (isNaN(timeA) && isNaN(timeB)) return 0;
          if (isNaN(timeA)) return 1;
          if (isNaN(timeB)) return -1;
          
          // Sort in descending order (newest first)
          return timeB - timeA;
        });
    });

    // Message is dispatched via socket-first flow (with centralized HTTP fallback in App.js).
    // No direct HTTP call here to avoid duplicate deliveries.
  };

  // 🚀 PHASE 7: Memoize goToChat to prevent unnecessary rerenders
  const goToChat = useCallback((id) => {
    const searchParams = new URLSearchParams(location.search);
    // 🔥 FIX: Clear all parameters when switching to a specific chat
    searchParams.delete("id");
    searchParams.delete("receiver");
    searchParams.delete("property");
    searchParams.delete("context");
    searchParams.delete("mode");
    searchParams.set("chat", id);
    navigate(location.pathname + `?${searchParams.toString()}`);
  }, [location.search, location.pathname, navigate]);

  const getChats = async (forceRefresh = false) => {
    if (!account) {
      console.log("No account available");
      return;
    }

    try {
      const res = await api("user/inbox", {
        account: account,
        timestamp: forceRefresh ? Date.now() : undefined, // Force refresh cache
      });

      if (res && Array.isArray(res)) {
        // Sort chats by latest message time (descending - newest first)
        const sortedChats = [...res].sort((a, b) => {
          const timeA = new Date(a.latestMessageTime).getTime();
          const timeB = new Date(b.latestMessageTime).getTime();
          
          // Debug logging for date sorting
          console.log("🔄 Sorting chats:", {
            chatA: a.chatId,
            timeA: a.latestMessageTime,
            parsedA: timeA,
            chatB: b.chatId,
            timeB: b.latestMessageTime,
            parsedB: timeB,
            comparison: timeB - timeA
          });
          
          // Handle invalid dates
          if (isNaN(timeA) && isNaN(timeB)) return 0;
          if (isNaN(timeA)) return 1;
          if (isNaN(timeB)) return -1;
          
          // Sort in descending order (newest first)
          return timeB - timeA;
        });

        setChats((prevChats) => {
          // Always update if it's a force refresh
          if (forceRefresh) {
            return sortedChats;
          }

          // If no previous chats, always update
          if (!prevChats || prevChats.length === 0) {
            return sortedChats;
          }

          // If length changed, update
          if (prevChats.length !== sortedChats.length) {
            return sortedChats;
          }

          // Check for changes in individual chat items
          let hasChanges = false;
          for (let i = 0; i < sortedChats.length; i++) {
            const newChat = sortedChats[i];
            const oldChat = prevChats.find((chat) => chat.chatId === newChat.chatId);

            if (
              !oldChat ||
              newChat.unreadMessages !== oldChat.unreadMessages ||
              newChat.latestMessageTime !== oldChat.latestMessageTime
            ) {
              hasChanges = true;
              break;
            }
          }

          return hasChanges ? sortedChats : prevChats;
        });
      } else {
        console.error("Invalid chat data received:", res);
        if (forceRefresh) {
          setChats([]);
        }
      }
    } catch (error) {
      console.error("Failed to fetch chats:", error);
      if (forceRefresh) {
        toast.error("Failed to refresh chats");
      }
    }
  };

  useEffect(() => {
    // Immediate force refresh on mount when account available
    getChats(true);

    // 🔥 OPTIMIZATION: Increased refresh interval from 30s to 60s
    const interval = setInterval(() => {
      getChats(true); // Force refresh periodically
    }, 60000); // 60 seconds instead of 30

    return () => clearInterval(interval);
  }, [account]);

  // Refetch chat list when opening Inbox from another page (e.g. Transactions) so list is never empty
  useEffect(() => {
    if (account && location.pathname && location.pathname.includes('/inbox')) {
      getChats(true);
    }
  }, [account, location.pathname]);

  // 🔥 OPTIMIZATION: Debounce focus/visibility refresh
  useEffect(() => {
    let focusTimeout;
    let visibilityTimeout;
    
    const handleFocus = () => {
      clearTimeout(focusTimeout);
      focusTimeout = setTimeout(() => {
        if (account) getChats(true);
      }, 500); // Debounce 500ms
    };
    
    const handleVisibility = () => {
      clearTimeout(visibilityTimeout);
      visibilityTimeout = setTimeout(() => {
        if (document.visibilityState === 'visible' && account) {
          getChats(true);
        }
      }, 500); // Debounce 500ms
    };
    
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibility);
    
    return () => {
      clearTimeout(focusTimeout);
      clearTimeout(visibilityTimeout);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [account]);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const urlChat = sp.get("chat");
    if (urlChat && urlChat !== prevChatParamRef.current) {
      prevChatParamRef.current = urlChat;
      dispatch(setReceivedMessage(null));
    }
    if (!urlChat) prevChatParamRef.current = null;
  }, [location.search, dispatch]);

  // 🔥 REMOVED: Unnecessary refresh when chat changes (causes extra API calls)
  // The socket updates will handle real-time updates instead

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [messages.length]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const newChat = searchParams.get("chat");
    const newNftId = searchParams.get("id");
    const newReceiver = searchParams.get("receiver");

    console.log("🔄 Location search changed:", {
      newChat,
      newNftId,
      newReceiver,
      currentChat: chat,
      currentNftId: nftId,
      currentReceiver: receiver,
    });

    // 🔥 FIX: Prioritize chat parameter, don't clear messages immediately
    if (newChat && newChat !== chat) {
      console.log("🔗 Setting chat from URL:", newChat);
      // 🔥 CRITICAL FIX: Load chat info FIRST before clearing anything
      // This ensures receiver/nftId are available immediately for real-time messaging
      const loadChatInfoImmediately = async () => {
        try {
          const res = await api("chat/getChattingInfo", {
            id: newChat,
            reader: account,
          });
          if (res) {
            console.log("✅ Chat info loaded immediately:", {
              receiver: res.receiver,
              nftId: res.nftId,
            });
            // Set receiver and nftId BEFORE setting chat to ensure real-time messaging works
            if (res.receiver) {
              setReceiver(res.receiver);
            }
            if (res.nftId && res.nftId !== 'undefined' && res.nftId !== 'null') {
              setNftId(res.nftId);
            } else {
              setNftId(null);
            }
            // Now set chat - receiver/nftId are already loaded
            setChat(newChat);
          } else {
            // Fallback: set chat even if info fails to load
            setChat(newChat);
            setNftId(null);
            setReceiver(null);
          }
        } catch (error) {
          console.error("Error loading chat info:", error);
          // Fallback: set chat even if info fails to load
          setChat(newChat);
          setNftId(null);
          setReceiver(null);
        }
      };
      
      if (account) {
        loadChatInfoImmediately();
      } else {
        // If no account, just set chat
        setChat(newChat);
        setNftId(null);
        setReceiver(null);
      }
      
      setTime(null);
      // Don't clear messages here - let getMessages handle it
    } else if (
      newNftId &&
      newReceiver &&
      (!chat || newNftId !== nftId || newReceiver !== receiver)
    ) {
      console.log("🔗 Setting property and receiver from URL:", {
        id: newNftId,
        receiver: newReceiver,
        mode: searchParams.get("mode"),
      });

      // Clear chat when setting new property/receiver combo
      setChat(null);
      setNftId(newNftId);
      setTime(null);
      // Resolve receiver to preferred address (EVM when reader is EVM) for profile/chat compatibility
      const loadAndFindChat = async () => {
        try {
          const resolved = await api("chat/resolveReceiver", {
            receiver: newReceiver,
            reader: account || newReceiver,
          });
          const resolvedReceiver = resolved?.receiver ?? newReceiver;
          setReceiver(resolvedReceiver);

          if (account) {
            const { chatId } = await findOrCreateChat(
              account,
              resolvedReceiver,
              newNftId,
              searchParams.get("mode") || "short",
              resolvedReceiver
            );
            if (chatId) {
              console.log("✅ Found existing chat, redirecting to:", chatId);
              goToChat(chatId);
            } else {
              console.log("🆕 No existing chat found, will create when sending first message");
              setMessages([]);
            }
          }
        } catch (error) {
          console.error("Error resolving receiver or finding chat:", error);
          setReceiver(newReceiver);
          setMessages([]);
          if (account) {
            try {
              const { chatId } = await findOrCreateChat(
                account,
                newReceiver,
                newNftId,
                searchParams.get("mode") || "short",
                newReceiver
              );
              if (chatId) goToChat(chatId);
              else setMessages([]);
            } catch (e) {
              setMessages([]);
            }
          }
        }
      };

      if (account) {
        loadAndFindChat();
      } else {
        setReceiver(newReceiver);
      }
    } else if (!newChat && !newNftId && !newReceiver) {
      // Clear everything if no parameters
      console.log("🔄 No parameters, clearing all chat state");
      setChat(null);
      setNftId(null);
      setReceiver(null);
      setTime(null);
      setMessages([]);
    }
  }, [location.search, account]);

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  // Simple emoji support
  const EMOJIS = [
    "😀","😁","😂","🤣","😊","😍","😘","😅","😉","😎",
    "🤔","🙄","😇","🙌","👍","🙏","👏","💯","🔥","🌟",
    "💜","🎉","✨","🥳","🤝","🤩","😌","😢","😭","😤"
  ];
  const addEmoji = (emoji) => {
    setText((prev) => (prev || "") + emoji);
    setTimeout(() => {
      try { inputRef.current?.focus(); } catch (e) {}
    }, 0);
  };

  // Image upload handler
  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('Please select an image file');
      return;
    }

    // Validate file size (10MB limit)
    if (file.size > 10 * 1024 * 1024) {
      toast.error('Image size must be less than 10MB');
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage({
        file: file,
        preview: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToPinata = async (file) => {
    try {
      setUploadingImage(true);
      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch(`${process.env.REACT_APP_BACKEND_SERVER}chat/uploadImage`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: setAuthToken(),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to upload image');
      }

      const data = await response.json();
      console.log('✅ Image uploaded to Pinata:', data.imageUrl);
      return data.imageUrl;
    } catch (error) {
      console.error('❌ Error uploading image:', error);
      toast.error('Failed to upload image');
      throw error;
    } finally {
      setUploadingImage(false);
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const getReview = async () => {
    if (!nftId || !account) {
      console.log("❌ Missing nftId or account for review check:", { nftId, account });
      return;
    }
    
    console.log("🔍 Fetching reviews for:", { nftId, account, mode, receiver });
    
    // 🔥 FIX: Check both traveler reviews (Review collection) AND host reviews (Profile collection)
    const [travelerReviewsRes, hostReviewsRes] = await Promise.all([
      api("review/get", { token_id: nftId }).catch(() => []),
      // Check if receiver has been reviewed by account (host reviewing traveler)
      receiver && mode === "host" && account === nft?.access?.owner
        ? api("profile/getProfile", { walletAddress: receiver }).catch(() => null)
        : Promise.resolve(null),
    ]);
    
    const travelerReviews = Array.isArray(travelerReviewsRes) ? travelerReviewsRes : [];
    const receiverProfile = hostReviewsRes;
    
    console.log("📝 Found", travelerReviews.length, "traveler reviews");
    console.log("📝 Receiver profile for host reviews:", receiverProfile ? "found" : "not found");
    
    let avgRate = 0;
    const reviewsMap = {};
    const accountLower = String(account).toLowerCase().trim();
    const receiverLower = receiver ? String(receiver).toLowerCase().trim() : null;
    const ownerLower = nft?.access?.owner
      ? String(nft?.access?.owner || "").toLowerCase().trim()
      : null;
    
    // Check traveler reviews (from Review collection - when account is the traveler/renter)
    for (let i = 0; i < travelerReviews.length; i++) {
      avgRate += travelerReviews[i].rate || 0;
      
      // 🔥 FIX: Normalize period values more robustly - handle both string and number types
      const reviewPeriod0 = travelerReviews[i].period?.[0];
      const reviewPeriod1 = travelerReviews[i].period?.[1];
      
      if (!reviewPeriod0 || !reviewPeriod1) continue;
      
      // Convert to numbers and then back to string for consistent comparison
      const period0 = Number(reviewPeriod0);
      const period1 = Number(reviewPeriod1);
      
      if (isNaN(period0) || isNaN(period1)) continue;
      
      const periodKey = `${period0}_${period1}`;
      
      // 🔥 FIX: More robust comparison - handle both string and number types
      const renterLower = travelerReviews[i].renter 
        ? String(travelerReviews[i].renter).toLowerCase().trim() 
        : null;
      
      // Check if account (as traveler) has reviewed this period
      if (renterLower && renterLower === accountLower) {
        reviewsMap[periodKey] = true;
        console.log("✅ Traveler review found - blocking button:", {
          period: periodKey,
          renter: travelerReviews[i].renter,
          account: account
        });
      }
    }
    
    // 🔥 NEW: Check host reviews (from Profile collection - when account is the host/owner)
    if (receiverProfile && receiverProfile.Reviews && Array.isArray(receiverProfile.Reviews)) {
      for (let i = 0; i < receiverProfile.Reviews.length; i++) {
        const hostReview = receiverProfile.Reviews[i];
        
        // Check if this review is from the account (host) for this property
        const reviewerLower = hostReview.owner 
          ? String(hostReview.owner).toLowerCase().trim() 
          : null;
        
        // Only check reviews from the account (when account is the host/owner)
        if (reviewerLower === accountLower && accountLower === ownerLower) {
          // 🔥 FIX: Normalize period values more robustly
          const reviewPeriod0 = hostReview.period?.[0];
          const reviewPeriod1 = hostReview.period?.[1];
          
          if (!reviewPeriod0 || !reviewPeriod1) continue;
          
          const period0 = Number(reviewPeriod0);
          const period1 = Number(reviewPeriod1);
          
          if (isNaN(period0) || isNaN(period1)) continue;
          
          const periodKey = `${period0}_${period1}`;
          
          // Check if this review is for the current property period
          // Match against reservations to find the period
          if (nft?.rentals?.rentals) {
            for (let j = 0; j < nft.rentals.rentals.length; j++) {
              const reservation = nft.rentals.rentals[j];
              const reservationPeriod0 = Number(reservation.renting_period?.[0]);
              const reservationPeriod1 = Number(reservation.renting_period?.[1]);
              
              if (reservationPeriod0 === period0 && reservationPeriod1 === period1 &&
                  reservation.address === receiver && reservation.approved && !reservation.cancelled) {
                reviewsMap[periodKey] = true;
                console.log("✅ Host review found - blocking button:", {
                  period: periodKey,
                  owner: hostReview.owner,
                  account: account,
                  receiver: receiver
                });
                break;
              }
            }
          }
        }
      }
    }
    
    // Calculate average rate from traveler reviews only (for property rating)
    if (travelerReviews.length > 0) {
      const totalRate = travelerReviews.reduce((sum, r) => sum + (r.rate || 0), 0);
      avgRate = totalRate / travelerReviews.length;
    }
    
    console.log("📊 Final reviews map:", reviewsMap);
    console.log("📊 Current account:", account);
    console.log("📊 Mode:", mode);
    console.log("📊 Receiver:", receiver);
    setAvgReviews(avgRate);
    setReviewsByPeriod(reviewsMap);
  };

  useEffect(() => {
    if (nftId && account) {
      console.log("🔄 Fetching reviews for nftId:", nftId, "account:", account);
      // Immediate fetch
      getReview();
      // Also fetch after a short delay to catch any async updates
      const timeout = setTimeout(() => {
        getReview();
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [nftId, account, mode, receiver, nft]); // 🔥 FIX: Add dependencies for proper review checking
  
  // Force refresh reviews when reservations change
  useEffect(() => {
    if (nftId && account && nft?.rentals?.rentals) {
      console.log("🔄 Reservations changed, refreshing reviews...");
      getReview();
    }
  }, [nft?.rentals?.rentals, nftId, account]);
  
  // Force refresh when component becomes visible (user navigates to this page)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && nftId && account) {
        console.log("🔄 Page visible, refreshing reviews...");
        getReview();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [nftId, account]);
  
  // Refresh reviews when reservation updates occur (e.g., after review submission)
  useEffect(() => {
    const handleReviewUpdate = () => {
      console.log("🔄 Review update detected, refreshing reviews...");
      if (nftId && account) {
        // Force refresh immediately
        setTimeout(() => {
          getReview();
        }, 500); // Small delay to ensure backend has processed
        // Also refresh after a longer delay to catch any async updates
        setTimeout(() => {
          getReview();
        }, 2000);
      }
    };
    
    window.addEventListener('reviewSubmitted', handleReviewUpdate);
    // Also listen for storage events (in case review is submitted in another tab)
    window.addEventListener('storage', handleReviewUpdate);
    
    return () => {
      window.removeEventListener('reviewSubmitted', handleReviewUpdate);
      window.removeEventListener('storage', handleReviewUpdate);
    };
  }, [nftId, account]);
  
  // Periodic refresh of reviews to ensure state is always up to date
  useEffect(() => {
    if (!nftId || !account) return;
    
    const interval = setInterval(() => {
      console.log("🔄 Periodic review refresh...");
      getReview();
    }, 10000); // Refresh every 10 seconds (more frequent for better UX)
    
    return () => clearInterval(interval);
  }, [nftId, account]);
  
  // Refresh reviews when window gains focus (user returns to tab)
  useEffect(() => {
    const handleFocus = () => {
      if (nftId && account) {
        console.log("Window focused, refreshing reviews...");
        getReview();
      }
    };
    
    window.addEventListener('focus', handleFocus);
    
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [nftId, account]);

  const getMessages = async (forceRefresh = false, retryCount = 0, loadMore = false) => {
    if (!chat) {
      console.log("❌ No chat ID provided, skipping message fetch");
      setMessages([]);
      return;
    }

    if (!account) {
      console.log("❌ No account provided, skipping message fetch");
      return;
    }

    console.log("🔄 Fetching messages for chat:", chat, "force:", forceRefresh, "retry:", retryCount, "loadMore:", loadMore);

    try {
      // 🔥 OPTIMIZATION: Only clear cache if it's a force refresh and not loading more
      if (forceRefresh && !loadMore) {
        const cacheKey = `chat/getMessages-${JSON.stringify({ id: chat, reader: account })}`;
        sessionStorage.removeItem(cacheKey);
      }
      
      // 🔥 NEW: Pagination support - get oldest message time if loading more
      const oldestMessage = loadMore && messages.length > 0 
        ? messages[0].generatedTime 
        : null;
      
      const res = await api("chat/getMessages", {
        id: chat,
        reader: account,
        limit: 50, // Load last 50 messages initially
        before: oldestMessage, // For pagination
      });

      console.log("📥 getMessages response:", res);

      if (res && res.chattingSession) {
        const backendMessages = res.chattingSession.messages || [];
        console.log("✅ Messages fetched:", backendMessages.length);
        console.log("📝 First few messages:", backendMessages.slice(0, 3));
        console.log("📝 Last few messages:", backendMessages.slice(-3));

        // 🔥 FIXED: Ensure all messages have properly encoded Unicode text
        const sanitizedBackendMessages = backendMessages.map((msg) => ({
          sender: String(msg.sender),
          generatedTime: msg.generatedTime,
          text: String(msg.text || ''), // 🔥 Ensure Unicode is preserved
          image: msg.image ? String(msg.image) : null, // 🔥 NEW: Include image URL
          messageType: msg.messageType || "text", // 🔥 NEW: Include message type
        }));

        // Log to verify emojis are present
        if (sanitizedBackendMessages.length > 0) {
          console.log("📝 First message text (first 50 chars):", sanitizedBackendMessages[0]?.text?.substring(0, 50));
          console.log("📝 Last message text (first 50 chars):", sanitizedBackendMessages[sanitizedBackendMessages.length - 1]?.text?.substring(0, 50));
        }

        const isShort = res.chattingSession.mode === "short" && (mode === "traveler" || mode === "host");
        const isLong = res.chattingSession.mode === "long" && (mode === "tenant" || mode === "landlord");

        if (isShort || isLong) {
          console.log(`✅ Setting ${isShort ? "SHORT" : "LONG"}-TERM messages:`, sanitizedBackendMessages.length);
          
          // 🔥 OPTIMIZATION: If loading more, prepend messages; otherwise replace
          setMessages((prevMessages) => {
            if (loadMore && prevMessages.length > 0) {
              const combined = [...sanitizedBackendMessages, ...prevMessages];
              return dedupeChatMessages(combined);
            }
            return dedupeChatMessages(sanitizedBackendMessages);
          });

          // 🔥 NEW: Set pagination state from backend response
          if (res.pagination) {
            setHasMoreMessages(res.pagination.hasMore || false);
          }

          setTime(
            sanitizedBackendMessages.length > 0
              ? sanitizedBackendMessages[sanitizedBackendMessages.length - 1]?.generatedTime
              : null
          );
        } else {
          console.log("⚠️ Mode mismatch:", {
            chatMode: res.chattingSession.mode,
            currentMode: mode,
          });
          setMessages([]);
        }
      } else {
        console.log("❌ No chat session found or invalid response");

        // 🔁 Retry if no response and retry count is low
        if (retryCount < 2) {
          console.log("🔄 Retrying message fetch in 1 second...");
          setTimeout(() => {
            getMessages(true, retryCount + 1, false);
          }, 1000);
          return;
        }

        setMessages([]);
      }
    } catch (error) {
      console.error("💥 Error fetching messages:", error);

      // 🔁 Retry on error if retry count is low
      if (retryCount < 2) {
        console.log("🔄 Retrying message fetch after error in 1 second...");
        setTimeout(() => {
          getMessages(true, retryCount + 1, false);
        }, 1000);
        return;
      }

      setMessages([]);
    }
  };

  useEffect(() => {
    if (chat) {
      for (let i = 0; i < notificationItems.length; i++) {
        if (
          notificationItems[i].type === "message" &&
          notificationItems[i].data.id === chat
        ) {
          dispatch(removeItem(i));
        }
      }
    }
  }, [notificationItems, chat]);

  // 🔥 OPTIMIZATION: Enhanced chat change handler with immediate refresh (no backup delay)
  useEffect(() => {
    if (chat && account) {
      console.log("🔄 Chat or account changed, fetching messages for:", chat);
      
      // Clear messages first to show loading state
      setMessages([]);
      setHasMoreMessages(false);
      
      // Immediate fetch without delay
      getMessages(true);
    } else {
      console.log("🔄 No chat or account, clearing messages");
      setMessages([]);
      setTime(null);
      setHasMoreMessages(false);
    }
  }, [chat, account, mode]);

  // 🔥 OPTIMIZATION: Reduced periodic refresh from 2min to 5min (socket handles real-time)
  useEffect(() => {
    if (!chat || !account) return;

    const interval = setInterval(() => {
      console.log("🔄 Periodic message refresh (fallback) for chat:", chat);
      getMessages(true);
    }, 300000); // 5 minutes instead of 2 (socket handles real-time)

    return () => clearInterval(interval);
  }, [chat, account]);

  const getProfile = async () => {
    if (!receiver) return;
    try {
      const profile = await getProfileFromWallet(receiver);
      setReceiverProfile(profile);
    } catch (error) {
      console.error("Error loading receiver profile:", error);
      setReceiverProfile(null);
    }
  };

  // 🔥 NEW: Get chat info (receiver, nftId) from chat ID when chat is selected from URL
  const getChattingInfo = async () => {
    if (!chat || !account) {
      console.log("❌ Missing chat or account for getChattingInfo");
      return;
    }

    try {
      console.log("🔄 Getting chatting info for chat:", chat);
      const res = await api("chat/getChattingInfo", {
        id: chat,
        reader: account,
      });

      if (res) {
        console.log("✅ Chatting info received:", {
          receiver: res.receiver,
          nftId: res.nftId,
        });

        // 🔥 FIX: Set receiver and nftId synchronously to ensure real-time messaging works
        // Do this BEFORE loading profile to ensure sendMessage can work immediately
        if (res.receiver) {
          setReceiver(res.receiver);
        }

        if (res.nftId && res.nftId !== 'undefined' && res.nftId !== 'null') {
          setNftId(res.nftId);
        } else {
          setNftId(null);
        }
      } else {
        console.log("❌ No response from getChattingInfo");
      }
    } catch (error) {
      console.error("💥 Error getting chatting info:", error);
    }
  };

  // 🔥 NEW: Load chat info when chat is selected from URL
  // 🔥 FIX: Ensure this runs immediately when chat is set, not waiting for receiver
  useEffect(() => {
    if (chat && account) {
      // Only fetch if we don't have receiver yet (chat loaded from URL)
      // This prevents unnecessary calls when receiver is already set
      const searchParams = new URLSearchParams(location.search);
      const urlChat = searchParams.get("chat");
      if (urlChat === chat && !receiver) {
        console.log("🔄 Chat selected from URL, loading chat info...");
        // Call immediately - don't wait
        getChattingInfo();
      }
    }
  }, [chat, account]);

  useEffect(() => {
    if (receiver) getProfile();
  }, [receiver]);

  // 🔥 DEBUG: Track message state changes
  useEffect(() => {
    console.log("📊 Messages state changed:", {
      count: messages.length,
      chat: chat,
      lastMessage: messages.length > 0 ? messages[messages.length - 1] : null,
    });
  }, [messages, chat]);

  // 🔥 FIX: Force refresh when entering a chat after navigation
  useEffect(() => {
    if (chat && account && mode) {
      // Check if this is a new chat session after navigation
      const currentUrl = window.location.href;
      console.log("🔄 Chat focused, checking message refresh for:", chat);
      
      // Small delay to ensure all state is settled
      const refreshTimeout = setTimeout(() => {
        console.log("� Forcing message refresh for chat:", chat);
        getMessages(true);
      }, 300);
      
      return () => clearTimeout(refreshTimeout);
    }
  }, [chat, account, mode, location.pathname]);

  // Smooth auto-scroll to bottom on new messages
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    try {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (e) {}
  };
  useEffect(() => {
    if (!isMobile) {
      scrollToBottom();
    }
  }, [messages.length, messages, isMobile]);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Render mobile version if on mobile
  if (isMobile) {
    return <InboxMobile mode={mode} />;
  }

  return (
    <div className="w-full h-[calc(100vh-70px)] p-[6px] sm:p-[8px] flex flex-col xl:flex-row gap-[6px] sm:gap-[8px]">
      <div className="border-[2px] p-[6px] sm:p-[8px] gap-[8px] w-full h-full rounded-[10px] bg-white flex flex-col lg:flex-row">
        {/* Chat List Section */}
        <div className="w-full lg:w-[350px] xl:w-[400px] h-[300px] lg:h-full">
          <div className="flex items-center gap-[6px] sm:gap-[8px]">
            <div className="scale-75 sm:scale-100">
              <MessagesInboxIcon />
            </div>
            <div className="text-[18px] sm:text-[20px]">Messages</div>
          </div>

          <div className="mb-[16px] sm:mb-[20px] mt-[8px] sm:mt-[10px] flex gap-[8px] sm:gap-[10px] items-center border-[#E3E3E3] border-[1px] rounded-[12px] pl-[12px] sm:pl-[16px] pr-[6px] sm:pr-[8px] py-[8px] sm:py-[9px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
            <div className="scale-75 sm:scale-100">
              <Messages />
            </div>
            <input 
              placeholder="Search" 
              className="w-full outline-none text-sm sm:text-base" 
            />
            <div className="scale-75 sm:scale-100">
              <Dashboardsearch />
            </div>
          </div>

          <div className="w-full h-[200px] lg:h-[calc(100vh-230px)] space-y-[8px] sm:space-y-[10px] pr-[4px] overflow-auto scrollbarwidth">
            {chats?.map((item, index) => {
              if (item.mode !== mode) return null;
              return (
                <div key={`chat-${item.chatId}-${index}`}>
                  <ChatItem
                    myChatId={item.chatId}
                    mode={mode}
                    time={item.chatId === chat ? time : null}
                    setNft={setNftId}
                    setReceiver={setReceiver}
                    setReceiverProfile={setReceiverProfile}
                  />
                </div>
              );
            })}
          </div>
        </div>

        {/* Chat Messages Section */}
        <div className="border-[2px] border-[#E3e3e3] w-full h-[400px] lg:h-full rounded-[10px] bg-[#F6F6F6] relative">
          {/* Only show header when a chat is selected */}
          {(receiver || chat) && (
            <div className="gap-2 sm:gap-3 border-b-[2px] rounded-t-[10px] border-[#e3e3e3] px-[8px] sm:px-[12px] py-[4px] sm:py-[6px] bg-white flex items-center">
              {receiverProfile && (
                <div className="p-[2px] w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] rounded-full bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee00]">
                  <NotificationImageWithFallback
                    src={receiverProfile?.Avatar}
                    alt="User Avatar"
                    className="w-full h-full rounded-full object-cover"
                    size="lg"
                  />
                </div>
              )}
              <div className="text-[16px] sm:text-[20px] truncate">
                {receiverProfile?.Name?.replace("/", " ") || "Loading..."}
              </div>
            </div>
          )}

          <div
            ref={ref}
            className="p-[6px] sm:p-[8px] h-[280px] lg:h-[calc(100vh-250px)] overflow-auto scrollbarwidth relative"
          >
            {!receiver && !chat ? (
              // Show empty state when no chat is selected
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <div className="rounded-md bg-white p-6 text-center max-w-sm">
                  <div className="text-base sm:text-lg font-medium text-gray-700 mb-2">
                    No messages yet
                  </div>
                  <div className="font-normal text-sm text-gray-500">
                    Select a chat from the list to start messaging
                  </div>
                </div>
              </div>
            ) : (
              messages.map((message, i) => {
              console.log("🔄 Rendering message:", {
                index: i,
                sender: message.sender,
                text: message.text?.substring(0, 30),
              });

              // 🔥 FIX: Simplified date handling using local time
              let messageTime;
              try {
                if (typeof message.generatedTime === "string") {
                  messageTime = new Date(message.generatedTime);
                } else if (message.generatedTime instanceof Date) {
                  messageTime = message.generatedTime;
                } else {
                  messageTime = new Date();
                }

                // Validate the date
                if (isNaN(messageTime.getTime())) {
                  console.error("Invalid message time:", message.generatedTime);
                  messageTime = new Date(); // Fallback to current time
                }
              } catch (error) {
                console.error("Error parsing message time:", error);
                messageTime = new Date(); // Fallback to current time
              }

              return (
                <React.Fragment
                  key={`${message.sender}-${message.text}-${i}-${message.generatedTime}`}
                >
                  <div className="w-full text-center text-[#B6B6B6] my-[8px] sm:my-[10px] text-xs sm:text-sm">
                    {i === 0 ? (
                      getDay(messageTime)
                    ) : (
                      <>
                        {(() => {
                          let prevMessageTime;
                          try {
                            if (typeof messages[i - 1].generatedTime === "string") {
                              prevMessageTime = new Date(messages[i - 1].generatedTime);
                            } else if (messages[i - 1].generatedTime instanceof Date) {
                              prevMessageTime = messages[i - 1].generatedTime;
                            } else {
                              prevMessageTime = new Date();
                            }

                            if (isNaN(prevMessageTime.getTime())) {
                              prevMessageTime = new Date();
                            }
                          } catch (error) {
                            prevMessageTime = new Date();
                          }

                          return getDay(messageTime) !== getDay(prevMessageTime)
                            ? getDay(messageTime)
                            : null;
                        })()}
                      </>
                    )}
                  </div>

                  {(() => {
                    // 🔥 FIX: Use defensive checks for sender comparison to handle type mismatches
                    const messageSender = String(message.sender || '');
                    const currentAccount = String(account || '');
                    const isSentMessage =
                      isSameWalletAddress(message.sender, account) ||
                      messageSender === currentAccount ||
                      message.sender == account;
                    
                    // Debug logging for message alignment issues
                    if (i === 0 || i === messages.length - 1) {
                      console.log("🔍 Message rendering check:", {
                        index: i,
                        messageSender,
                        currentAccount,
                        isSentMessage,
                        strictMatch: message.sender === account,
                        looseMatch: message.sender == account
                      });
                    }
                    
                    return isSentMessage ? (
                      <SentMessage 
                        text={message.text} 
                        image={message.image}
                        messageType={message.messageType}
                        time={getTime(messageTime)} 
                      />
                    ) : (
                      <ReceivedMessage 
                        text={message.text} 
                        image={message.image}
                        messageType={message.messageType}
                        time={getTime(messageTime)} 
                      />
                    );
                  })()}
                </React.Fragment>
              );
            })
            )}
            <div ref={messagesEndRef} />
            {receiver && messages.length === 0 && (
              <div className="absolute top-0 left-0 w-full h-full bg-[#B2B2B2A0] flex flex-col items-center justify-center p-4">
                <div className="rounded-md bg-white p-3 text-center">
                  <div className="text-sm sm:text-base">No messages here yet...</div>
                  <div className="font-normal text-xs sm:text-sm">
                    Send a message to chat with{" "}
                    <div className="font-medium">
                      {receiverProfile?.Name?.replace("/", " ")}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Only show message input when a chat is selected */}
          {(receiver || chat) && (
            <div className="flex w-full px-[12px] sm:px-[20px] gap-[8px] sm:gap-[16px] absolute bottom-[8px] sm:bottom-[20px]">
              <div className="gap-[8px] sm:gap-[10px] rounded-[12px] flex items-center px-[8px] sm:px-[12px] py-[8px] sm:py-[10px] w-full bg-white shadow-md shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] relative">
              <div
                className="scale-75 sm:scale-100 cursor-pointer select-none"
                role="button"
                aria-label="Open emoji picker"
                onClick={() => setShowEmojiPicker((s) => !s)}
              >
                <TypeMessage />
              </div>

              <input
                placeholder="Type Message.."
                className="w-full outline-none text-sm sm:text-base"
                onChange={(e) => setText(e.target.value)}
                value={text}
                onKeyDown={handleEnterKey}
                ref={inputRef}
              />
              {/* Hidden file input */}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageSelect}
                className="hidden"
              />
              <div
                className="scale-75 sm:scale-100 cursor-pointer select-none"
                role="button"
                aria-label="Upload image"
                onClick={() => fileInputRef.current?.click()}
              >
                <TypeSearch />
              </div>
            </div>
            {/* Image preview */}
            {selectedImage && (
              <div className="absolute bottom-[72px] sm:bottom-[84px] left-[12px] sm:left-[20px] bg-white border border-[#E3E3E3] rounded-[10px] p-2 shadow-lg z-10 max-w-[200px] sm:max-w-[300px]">
                <div className="relative">
                  <img
                    src={selectedImage.preview}
                    alt="Preview"
                    className="rounded-[8px] w-full max-h-[200px] object-cover"
                  />
                  <button
                    onClick={removeSelectedImage}
                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-[24px] h-[24px] flex items-center justify-center text-xs hover:bg-red-600"
                    aria-label="Remove image"
                  >
                    ×
                  </button>
                </div>
                {uploadingImage && (
                  <div className="text-xs text-gray-500 mt-2 text-center">Uploading...</div>
                )}
              </div>
            )}
            {showEmojiPicker && (
              <div className="absolute bottom-[64px] sm:bottom-[76px] left-[8px] sm:left-[12px] bg-white border border-[#E3E3E3] rounded-[10px] p-2 shadow-lg w-[240px] sm:w-[280px] max-h-[200px] overflow-auto z-10">
                <div className="grid grid-cols-8 gap-1 text-xl">
                  {EMOJIS.map((emj, idx) => (
                    <button
                      key={`emoji-${idx}`}
                      className="hover:bg-[#f3f3f3] rounded p-[2px]"
                      onClick={() => addEmoji(emj)}
                    >
                      {emj}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div
              className="bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] p-[12px] sm:p-[16px] cursor-pointer text-white shadow-[-1px_3px_3px_0_rgba(80,80,80,0.2)] rounded-[12px] font-semibold hover:shadow-[-1px_6px_10px_0_rgba(93,0,207,0.5)] hover:-translate-y-[3px] scale-75 sm:scale-100"
              onClick={() => {
                sendMessage();
              }}
            >
              <SendMessage />
            </div>
          </div>
          )}
        </div>
      </div>

      {/* Property Details Section */}
      {/* 🚀 PHASE 7: Show loading state when NFT is being loaded */}
      {nftId && (nft || isLoadingNft) ? (
        <div className="p-[6px] sm:p-[8px] border-[2px] min-w-[280px] w-full xl:w-[380px] scrollbarwidth h-[600px] xl:h-full max-h-[calc(100vh-90px)] overflow-y-auto rounded-[10px] bg-white">
          <div className="flex gap-[8px] sm:gap-[10px] items-center mb-[4px]">
            <div className="scale-75 sm:scale-100">
              <RentalRequest />
            </div>
            <div className="text-[16px] sm:text-[20px] font-semibold">Rental Request</div>
          </div>

          {/* 🚀 PHASE 7: Show loading skeleton when NFT is loading */}
          {isLoadingNft && !nft ? (
            <div className="rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] p-[12px] space-y-[12px]">
              <Skeleton height={160} style={{ borderRadius: "8px" }} />
              <Skeleton height={20} width="80%" />
              <Skeleton height={16} width="60%" />
              <Skeleton height={16} width="70%" />
              <Skeleton height={40} width="100%" />
            </div>
          ) : nft ? (
            <div className="rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
              <div className="rounded-t-[8px] w-full h-[140px] sm:h-[160px] relative overflow-hidden">
                <RentalItem
                  token_id={nft.token_id}
                  onlyImages
                  borderNone
                  rentingPeriod={firstPeriod}
                  traveler={travelerAddress}
                  tokenData={nft}
                />
              </div>

              <div className="py-[8px] sm:py-[10px] mx-auto px-[6px] sm:px-[8px] space-y-[4px] sm:space-y-[6px] flex flex-col items-center">
                <div className="flex justify-between w-full items-center">
                  <div className="text-sm sm:text-base font-medium truncate flex-1 mr-2">
                    {nft?.metaData?.buildingName || "Property"}
                  </div>
                  <div className="flex items-center gap-[6px] sm:gap-[10px] flex-shrink-0">
                    <div className="p-[4px] sm:p-[6px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)] scale-75 sm:scale-100">
                      <FavoriteIconRent />
                    </div>
                    <div className="text-[#959595] text-xs sm:text-sm">{avgRate}</div>
                  </div>
                </div>

                <div className="flex w-full gap-[4px] items-center">
                  <div className="scale-75 sm:scale-100">
                    <Addressfile />
                  </div>
                  <div className="w-full truncate text-xs sm:text-sm">
                    {/* 🚀 PHASE 7: Fix undefined address error with proper optional chaining */}
                    {nft?.metaData?.address?.street || ""} {nft?.metaData?.address?.city || ""}{" "}
                    {nft?.metaData?.address?.state || ""}
                  </div>
                </div>

                {/* Property Description */}
                {nft?.metaData?.description && (
                  <>
                    <div className="w-full h-[2px] bg-[#E3E3E3]" />
                    <div className="w-full">
                      <div className="text-[#A4A4A4] text-xs sm:text-sm mb-[4px] sm:mb-[6px]">Description</div>
                      <div className="text-[#959595] text-xs sm:text-sm line-clamp-3 max-h-[60px] overflow-hidden">
                        {nft.metaData.description}
                      </div>
                    </div>
                  </>
                )}

              <div className="w-full h-[2px] bg-[#E3E3E3]" />

              <div className="flex w-full items-center gap-[4px]">
                <div className="scale-75 sm:scale-100">
                  <Essential />
                </div>
                <div className="text-[#A4A4A4] text-xs sm:text-sm">Essentials</div>
              </div>

              <div className="flex items-center gap-[6px] sm:gap-[10px] w-full justify-center">
                <div className="flex items-center gap-[6px] sm:gap-[10px]">
                  <div className="p-[4px] sm:p-[6px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)] scale-75 sm:scale-100">
                    <GuestsIcon />
                  </div>
                  <div className="text-[#959595] text-xs sm:text-sm">
                    {nft?.metaData?.essentials?.guests || 0}
                  </div>
                </div>
                <div className="w-[1px] h-[16px] sm:h-[20px] bg-[#959595]"></div>
                <div className="flex items-center gap-[6px] sm:gap-[10px]">
                  <div className="p-[4px] sm:p-[6px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)] scale-75 sm:scale-100">
                    <BathRoomIconRent />
                  </div>
                  <div className="text-[#959595] text-xs sm:text-sm">
                    {nft?.metaData?.essentials?.bathrooms || 0}
                  </div>
                </div>
                <div className="w-[1px] h-[16px] sm:h-[20px] bg-[#959595]"></div>

                <div className="flex items-center gap-[6px] sm:gap-[10px]">
                  <div className="p-[4px] sm:p-[6px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)] scale-75 sm:scale-100">
                    <BedIconRent />
                  </div>
                  <div className="text-[#959595] text-xs sm:text-sm">
                    {nft?.metaData?.essentials?.beds || 0}
                  </div>
                </div>
              </div>

              {nft?.rentals?.rentals?.some(
                (item) => item.address === account && isRentalActive(item, diff)
              ) ? (
                <>
                  <div className="flex gap-[6px] sm:gap-[10px] items-center">
                    <div className="scale-75 sm:scale-100">
                      <Active />
                    </div>
                    <div className="text-[#321083] text-xs sm:text-sm">Renting is still active</div>
                  </div>
                  <div className="w-full">
                    <PurpleButton
                      onClick={() =>
                        navigate(
                          `/dashboard/traveler/trips/${nft.token_id}?from=${firstPeriod[0]}&to=${firstPeriod[1]}`
                        )
                      }
                      text={
                        <div className="w-full text-center text-sm sm:text-base">Rental Details</div>
                      }
                    />
                  </div>
                  <div className="w-full h-[2px] bg-[#E3E3E3]" />
                  <div className="flex w-full items-center gap-[4px]">
                    <div className="scale-75 sm:scale-100">
                      <Rental />
                    </div>
                    <div className="text-[#A4A4A4] text-xs sm:text-sm">Rental Period</div>
                  </div>
                </>
              ) : (
                <></>
              )}

              {nft?.rentals?.rentals?.map((reservation, index) => {
                // 🔥 FIX: Only show active rentals or recently completed rentals (within 2 days)
                const shouldShow = shouldShowRentalInInbox(reservation, diff);
                
                if (
                  ((reservation.address === account && mode === "traveler") ||
                  (reservation.address === receiver && mode === "host")) &&
                  shouldShow
                )
                  return (
                    <div key={index} className="w-full justify-between flex items-center">
                      <div className="py-[3px] sm:py-[4px] px-[8px] sm:px-[12px] w-max bg-[#F6F6F6] rounded-[8px] text-xs sm:text-sm">
                        {new Date(
                          (reservation.renting_period[0] - diff) * 1000
                        )?.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                      <div className="w-[12px] sm:w-[16px] h-[2px] bg-[#B6B6B6]"></div>
                      <div className="py-[3px] sm:py-[4px] px-[8px] sm:px-[12px] w-max bg-[#F6F6F6] rounded-[8px] text-xs sm:text-sm">
                        {new Date(
                          (reservation.renting_period[1] - diff) * 1000
                        )?.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    </div>
                  );
                else return <></>;
              })}

              <div className="w-full h-[2px] bg-[#E3E3E3]" />
              <div className="flex gap-[4px] w-full items-center">
                <div className="scale-75 sm:scale-100">
                  <Host />
                </div>
                <div className="text-[#A4A4A4] text-xs sm:text-sm">
                  {mode === "host" && "Traveler"}
                  {mode === "traveler" && "Host"}
                </div>
              </div>

              <div className="flex items-center w-full justify-between">
                <div className="flex gap-[6px] sm:gap-[10px] items-center flex-1 min-w-0">
                  <NotificationImageWithFallback
                    src={receiverProfile?.Avatar}
                    alt="Avatar"
                    className="flex-shrink-0"
                    size="md"
                  />
                  <div className="text-sm sm:text-base truncate">
                    {receiverProfile?.Name?.replace("/", " ")}
                  </div>
                </div>
                {receiverProfile?.isVerified && (
                  <div className="scale-75 sm:scale-100 flex-shrink-0">
                    <svg
                      width="54"
                      height="54"
                      viewBox="0 0 54 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_dd_1245_86717)">
                        <rect
                          x="11"
                          y="11"
                          width="32"
                          height="32"
                          rx="16"
                          fill="#5B1DEE"
                        />
                        <rect
                          x="11"
                          y="11"
                          width="32"
                          height="32"
                          rx="16"
                          fill="url(#paint0_linear_1245_86717)"
                          fillOpacity="0.18"
                        />
                        <g filter="url(#filter1_d_1245_86717)">
                          <path
                            d="M33.0248 25.1083C32.7767 24.8748 32.52 24.6341 32.4165 24.4161C32.3209 24.2165 32.2982 23.8784 32.2761 23.551C32.2348 22.9423 32.1886 22.2526 31.6835 21.7978C31.1784 21.3429 30.4875 21.3691 29.8779 21.3917C29.55 21.4039 29.2114 21.4166 29.0029 21.3424C28.7759 21.2623 28.5091 21.0322 28.2508 20.8098C27.7985 20.4186 27.2846 19.9755 26.633 20.0096C25.9814 20.0438 25.5172 20.5381 25.1076 20.9745C24.8741 21.2227 24.6334 21.4794 24.4154 21.5828C24.217 21.6784 23.8777 21.7011 23.5503 21.7233C22.9416 21.7646 22.2519 21.8108 21.7971 22.3159C21.3422 22.821 21.3716 23.5117 21.391 24.1215C21.4032 24.4494 21.4159 24.788 21.3417 24.9965C21.2616 25.2235 21.0315 25.4903 20.8091 25.7485C20.4179 26.2009 19.9748 26.7148 20.0089 27.3664C20.0431 28.018 20.5374 28.4821 20.9738 28.8917C21.222 29.1253 21.4787 29.366 21.5821 29.584C21.6777 29.7836 21.7004 30.1216 21.7226 30.449C21.7639 31.0577 21.8101 31.7475 22.3152 32.2023C22.8203 32.6571 23.5111 32.6309 24.1208 32.6084C24.4487 32.5962 24.7873 32.5835 24.9958 32.6576C25.2228 32.7377 25.4896 32.9678 25.7478 33.1903C26.2002 33.5815 26.7141 34.0246 27.3657 33.9904C28.0173 33.9563 28.4814 33.4619 28.891 33.0255C29.1246 32.7773 29.3653 32.5206 29.5833 32.4172C29.7829 32.3216 30.1209 32.2989 30.4484 32.2768C31.057 32.2355 31.7468 32.1893 32.2016 31.6842C32.6564 31.1791 32.6302 30.4882 32.6077 29.8786C32.5955 29.5506 32.5828 29.2121 32.6569 29.0036C32.7371 28.7766 32.9672 28.5098 33.1896 28.2515C33.5808 27.7992 34.0239 27.2853 33.9897 26.6337C33.9556 25.9821 33.4613 25.5179 33.0248 25.1083ZM29.7892 25.706L26.4772 29.3844C26.4332 29.4332 26.3801 29.4729 26.3208 29.5013C26.2615 29.5296 26.1972 29.5459 26.1316 29.5493C26.0659 29.5528 26.0003 29.5432 25.9384 29.5213C25.8764 29.4993 25.8194 29.4654 25.7706 29.4214L24.1942 28.002C24.0956 27.9132 24.0363 27.7889 24.0293 27.6564C24.0224 27.5239 24.0684 27.394 24.1572 27.2954C24.2459 27.1968 24.3702 27.1375 24.5027 27.1306C24.6352 27.1236 24.7651 27.1696 24.8637 27.2584L26.0684 28.3437L29.0456 25.0365C29.0896 24.9877 29.1427 24.948 29.202 24.9197C29.2613 24.8914 29.3256 24.8751 29.3912 24.8717C29.4568 24.8682 29.5225 24.8777 29.5844 24.8997C29.6463 24.9216 29.7033 24.9555 29.7522 24.9995C29.801 25.0434 29.8407 25.0966 29.8689 25.1559C29.8972 25.2152 29.9136 25.2795 29.917 25.3451C29.9204 25.4107 29.9109 25.4763 29.889 25.5382C29.8671 25.6002 29.8331 25.6572 29.7892 25.706Z"
                            fill="white"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_dd_1245_86717"
                          x="0.333331"
                          y="0.333331"
                          width="53.3333"
                          height="53.3333"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="2.66667" dy="2.66667" />
                          <feGaussianBlur stdDeviation="4" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1245_86717"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="-2.66667" dy="-2.66667" />
                          <feGaussianBlur stdDeviation="4" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="effect1_dropShadow_1245_86717"
                            result="effect2_dropShadow_1245_86717"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect2_dropShadow_1245_86717"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_1245_86717"
                          x="20.0068"
                          y="20.0078"
                          width="14.9844"
                          height="14.9844"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="1" dy="1" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1245_86717"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1245_86717"
                            result="shape"
                          />
                        </filter>
                        <linearGradient
                          id="paint0_linear_1245_86717"
                          x1="27"
                          y1="11"
                          x2="27"
                          y2="31.6667"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="white" />
                          <stop offset="1" stop-color="white" stop-opacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                )}
              </div>

              <div className="w-full space-y-2">
                <PurpleButton
                  onClick={() => navigate(`/dashboard/profile/${receiver}`)}
                  text={<div className="w-full text-center text-sm sm:text-base">See Profile</div>}
                />
                {mode === "traveler" && (
                  <BlackButton
                    text={<div className="text-sm sm:text-base">View Listing</div>}
                    onClick={() => navigate(`/rent/all/${nftId}`)}
                  />
                )}
              </div>
            </div>

            {nft?.rentals?.rentals?.map((reservation, index) => {
              // 🔥 FIX: Only show active rentals or recently completed rentals (within 2 days)
              const shouldShow = shouldShowRentalInInbox(reservation, diff);
              
              if (
                ((reservation.address === account && mode === "traveler") ||
                (reservation.address === receiver && mode === "host")) &&
                shouldShow
              )
                return (
                <div key={`reservation-${reservation.address}-${index}`}>
                  <div className="my-[8px] sm:my-[10px] flex gap-[4px] sm:gap-[6px] items-center text-[16px] sm:text-[18px] pl-[4px]">
                    <div className="scale-75 sm:scale-100">
                      <Billing />
                    </div>
                    <div>Billing Details</div>
                  </div>
                  <div className="space-y-[8px] sm:space-y-[10px] p-[12px] sm:p-[16px] rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                    <div className="w-full flex justify-between">
                      <div className="text-[#959595] text-sm sm:text-base">Guest</div>
                      <div className="text-[#959595] text-sm sm:text-base">
                        {reservation.guests} guest
                      </div>
                    </div>
                    <hr />
                    <div className="w-full flex justify-between">
                      <div className="text-[#959595] text-sm sm:text-base">Daily Cost</div>
                      <div className="flex items-center gap-[6px] sm:gap-[10px]">
                        <div className="scale-75 sm:scale-100">
                          <NUSDIcon />
                        </div>
                        <div className="text-[#959595] text-sm sm:text-base">
                          {nft?.short.price_per_day} USDC
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="w-full flex justify-between">
                      <div className="text-sm sm:text-base">Total Payment</div>
                      <div className="flex items-center gap-[6px] sm:gap-[10px]">
                        <div className="scale-75 sm:scale-100">
                          <NUSDIcon />
                        </div>
                        <div className="text-[#959595] text-sm sm:text-base">
                          {(
                            Number(reservation.deposit_amount) /
                            10 ** process.env.REACT_APP_USDC_DECIMALS
                          ).toString()}{" "}
                          USDC
                        </div>
                      </div>
                    </div>
                  </div>
                  {account === nft?.access.owner ? (
                    <HostAction
                      token_id={nft.token_id}
                      approved={reservation.approved}
                      cancelled={reservation.cancelled}
                      rentingPeriod={reservation.renting_period}
                      traveler={reservation.address}
                      fundedAmount={
                        (
                          Number(reservation.deposit_amount) /
                          10 ** process.env.REACT_APP_USDC_DECIMALS
                        ).toString()
                      }
                      reviewPlaced={false}
                    />
                  ) : (
                    <TravelerAction
                      token_id={nft.token_id}
                      approved={reservation.approved}
                      cancelled={reservation.cancelled}
                      rentingPeriod={reservation.renting_period}
                      fundedAmount={
                        (
                          Number(reservation.deposit_amount) /
                          10 ** process.env.REACT_APP_USDC_DECIMALS
                        ).toString()
                      }
                      reviewPlaced={
                        (() => {
                          // Normalize period values to numbers for consistent comparison
                          const period0 = Number(reservation.renting_period[0]);
                          const period1 = Number(reservation.renting_period[1]);
                          const periodKey = `${period0}_${period1}`;
                          const hasReview = reviewsByPeriod[periodKey] || false;
                          console.log("🔍 TravelerAction - Checking review:", {
                            periodKey,
                            hasReview,
                            reviewsByPeriod,
                            reservationPeriod: reservation.renting_period,
                            account,
                            isTraveler: account !== nft?.access.owner
                          });
                          return hasReview;
                        })()
                      }
                    />
                  )}
                </div>
                );
              else return null;
            })}
          </div>
          ) : null}
        </div>
      ) : null}

      <ProfileRequiredModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        onCreateProfile={() => {
          setShowProfileModal(false);
          navigate("/dashboard/profile?mode=traveler");
        }}
        action="send messages"
      />
    </div>
  );
};
